import React, { PropsWithChildren } from 'react';
import styles from './dictionary-components.module.scss';

export default function AkNoWrap({ children }: PropsWithChildren<{}>) {
    return <span className={styles.wwiseAkNoWrap}>{children}</span>;
}
